import Backbone from 'backbone'
import _ from 'underscore'
import TextTemplate from '../templates/text.tpl'
import user from '../user'

const UserOptionView = Backbone.View.extend({
    tagName: 'option',
    initialize() {
        this.template = _.template(TextTemplate)
    },
    render() {
        this.$el.val(this.model.get('id'))
        if (this.model.get('id') === user.get('uid')) {
            this.$el.attr('selected', 'selected')
        }
        this.$el.html(this.template({text: this.model.get('firstname') + ' ' + this.model.get('lastname')}))
        return this
    }
})

export default UserOptionView
